<template>
    <content-layout>
        <h1 slot="header" class="category-title">Manas grāmatzīmes</h1>

        <div class="row my-category">
            <div class="small-6 medium-4 large-2 column sidebar">
                <my-profile-info v-if="user" class="profile-info"></my-profile-info>
            </div>
            <div class="small-6 medium-8 large-10 column content">
                <h4 class="breadcrumb">
                    <span class="crumb"><router-link :to="{ name: 'profile' }">Mans profils</router-link></span>
                    <span class="crumb">Manas grāmatzīmes</span>
                </h4>

                <div v-if="materials.length > 0" class="file-list-container row small-up-2 medium-up-3 large-up-4">
                    <div class="column" v-for="material in materials">
                        <my-material-item :material="material"></my-material-item>
                    </div>
                </div>

                <div v-if="materials.length > 0" class="pagination-container">
                    <pagination :current.sync="page" :total="pages"></pagination>
                </div>
            </div>
        </div>
    </content-layout>
</template>

<script>
    import ContentLayout from '../../layouts/ContentLayout'
    import MyProfileInfo from '../../components/profile/MyProfileInfo'
    import MyMaterialItem from '../../components/MyMaterialItem'
    import Pagination from '../../components/common/Pagination'
    import { mapGetters } from 'vuex'
    import user from "../../api/user";

    export default {

        created() {
            if (this.user) {
                this.getBookmarks()
            }
        },

        data() {
            return {
                page: 1,
                materials: [],
                pages: 1,
            }
        },

        computed: {

            ...mapGetters(['user']),
        },

        methods: {
            /**
             * Get User materials or bookmarks.
             */
            getBookmarks() {

                return user.bookmarks({ page: this.page })
                    .then(response => {
                        console.log('got bookmarks', response.data);
                        this.setMaterial(response.data);
                        return response;
                    })
            },

            /**
             * Set materials from API response data
             *
             * @param {Array} data
             * @param {Object} meta
             */
            setMaterial({ data, meta }) {
                this.materials = data;
                this.pages = meta ? meta.last_page : 1;
                this.page = meta ? meta.current_page : 1;
            },

            reset() {
                Object.assign(this.$data, this.$options.data.apply(this))//Resetting component data
            }
        },

        watch: {

            'user': function (val) {
                if (val) {
                    this.getBookmarks()
                }
            },

            /**
             *
             * @param val
             * @param oldVal
             */
            page: function (val, oldVal) {
                if (typeof val !== 'undefined' && val !== null  && val !== oldVal) {
                    this.getBookmarks();
                }
            }
        },

        components: {
            ContentLayout, MyProfileInfo, Pagination, MyMaterialItem
        }
    }
</script>

<style lang="scss" scoped="">

    .sidebar,
    .content {
        padding-top:  30px;
    }

    //TODO duplicate
    .file-list-container {
        padding-bottom: 1.875rem;
    }

    //TODO duplicate
    .pagination-container {
        text-align: center;
    }


    //TODO create breadcrumb
    .breadcrumb {
        margin-bottom: 2rem;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/views/profile/MyBookmarks.vue